var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf"},[_c('div',{staticClass:"back"},[_c('div',{staticClass:"back-icon",on:{"click":function($event){return _vm.jump()}}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("人脸注册照片规范说明")])]),_vm._v(" "),_c('pdf',{attrs:{"src":"http://sc.geemi.cn/timeloit/webpage/wechat/static/test.pdf"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc1c976","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pdf/index.vue
// module id = null
// module chunks = 